import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { C_AudioPlayBackItem } from '../models/alarm/domain/alarm-config.model';

@Injectable({
  providedIn: 'root'
})
export class AlarmService implements OnDestroy {
  // objeto audio
  // Intervalo

  private audio: HTMLAudioElement = new Audio();
  private isPlaying: boolean = false;
  private playBackStatusQueue: string[] = [];

  // private enumStatus:enum = {PLAY, PAUSE}
  private audioPlayBackQueue: C_AudioPlayBackItem[] = [];
  private currentAudio?: C_AudioPlayBackItem;
  private $playBackInUse: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  private intervalId?: ReturnType<typeof setTimeout>;
  public audioMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private audioIsActive = false;
  constructor(private router: Router) { }

  ngOnDestroy(): void {
    clearTimeout(this.intervalId);
  }
  getCurrentRoute(): string {
    return this.router.url;
  }
  public getAudioMode(): Observable<boolean> {
    return this.audioMode.asObservable();
  }
  public changeAudioState() {
    this.audioIsActive = !this.audioIsActive;
    this.audioMode.next(this.audioIsActive);

    if (this.audioIsActive) {
      this.shouldBePlaying();
    } else {
      this.mustStop();
    }
  }

  private managePlayBackQueue() {
    if (this.playBackStatusQueue.length) {
      const status = this.playBackStatusQueue.splice(0, 1)[0];
      switch (status) {
        case 'PLAY':
          if (this.audioIsActive && this.checkCurrentBox()) this.audio.play();
          break;
        case 'PAUSE':
          this.audio.pause();
          break;
        case 'INIT':
          this.isPlaying = true;
          this.audio.autoplay = false;
          this.audio.src = this.currentAudio!.audioToPlay!;
          this.audio.loop = true;
          break;
      }
      setTimeout(() => {
        this.managePlayBackQueue();
      });
    } else {
      this.$playBackInUse.next(false);
    }
  }
  // InitPlayBackInterval
  // Cambiar ms to execute 25ms por configuración
  // Array más cercano de tiempos de expiración?
  // Tener en cuenta posición 0
  /**
   *
   */
  public initPlayBackInterval() {
    //this.stopPlayBackInterval();
    if (
      !this.isPlaying &&
      this.currentAudio &&
      this.currentAudio.audioToPlay != null
    ) {
      this.isPlaying = true;
      this.audio.autoplay = false;
      this.audio.src = this.currentAudio.audioToPlay;
      this.audio.loop = true;

      //this.audio.play();
      this.playBackStatusQueue.push('INIT');
      this.playBackStatusQueue.push('PLAY');

      if (!this.$playBackInUse.getValue()) {
        this.$playBackInUse.next(true);
        this.managePlayBackQueue();
      }

      this.intervalId = setTimeout(() => {
        this.stopAndPlayNextInterval();
      }, this.currentAudio.duration);
    }
  }

  public addToQueue(obs: C_AudioPlayBackItem) {
    // está sonando?
    // si
    // Tiene mayor prioridad?
    // si para la actual y reproduce la nueva
    // no
    // Reproducela
    this.audioPlayBackQueue.push(obs);
    if (this.isPlaying) {
      if (this.currentAudio?.priority! > obs.priority) {
        this.stopAndPlayNextInterval();
      }
    } else {
      this.checkNextAudioInQueue();
    }
  }

  public expireObs(obs: C_AudioPlayBackItem) {
    let obsFound = this.audioPlayBackQueue.findIndex(
      (obsItemList) =>
        obs.patientId == obsItemList.patientId && obs.value == obsItemList.value
    );
    if (obsFound != -1) this.audioPlayBackQueue.splice(obsFound, 1);
    if (obsFound == 0) this.stopAndPlayNextInterval();
  }

  /**
   *
   */
  public stopAndPlayNextInterval() {
    //this.audio.pause();
    this.playBackStatusQueue.push('PAUSE');
    this.isPlaying = false;
    if (!this.$playBackInUse.getValue()) {
      this.$playBackInUse.next(true);
      this.managePlayBackQueue();
    }
    //this.audio.currentTime = 0;
    clearTimeout(this.intervalId);
    this.checkNextAudioInQueue();
  }

  public checkNextAudioInQueue() {
    this.orderByPrioAndTime(this.audioPlayBackQueue);

    this.expirationFilter();
    if (this.audioPlayBackQueue) {
      this.currentAudio = this.audioPlayBackQueue[0];
      //this.currentAudio = copy[0];
      this.initPlayBackInterval();
    }
  }
  private orderByPrioAndTime(validObservations: C_AudioPlayBackItem[]) {
    // let c = validObservations.sort((a, b) => {
    //   // Compara por prioridad (de menor a mayor)
    //   if (a.priority! < b.priority!) {
    //     return -1;
    //   }
    //   if (a.priority! > b.priority!) {
    //     return 1;
    //   }

    //   // Si las prioridades son iguales, compara por tiempo (de más reciente a más antiguo)
    //   if (a.time && b.time) {
    //     return b.time.getTime() - a.time.getTime();
    //   }

    //   return 0; // Si las prioridades y el tiempo son iguales, no hay diferencia.
    // });
  }
  private expirationFilter(): void {
    // Filtra las observaciones que no han caducado
    const validObservations = this.audioPlayBackQueue.filter(
      (obs) => !obs.isExpired()
    );

    // Reemplaza la lista original con las observaciones válidas y ordenadas
    this.audioPlayBackQueue = validObservations;
  }
  /**
   * Reiniciar lista de reproducción
   */
  public resetPlayBackInterval() {
    this.isPlaying = false;
    this.audio.currentTime = 0;
    this.playBackStatusQueue.push('PAUSE');
    if (!this.$playBackInUse.getValue()) {
      this.$playBackInUse.next(true);
      this.managePlayBackQueue();
    }
    clearTimeout(this.intervalId);
    this.audioPlayBackQueue = [];
    this.audio.loop = false;
  }

  private shouldBePlaying() {
    if (this.isPlaying) this.audio.play();
  }

  private mustStop() {
    if (this.isPlaying) this.audio.pause();
  }

  private checkCurrentBox() {
    if (this.getCurrentRoute().startsWith('/display/' + this.currentAudio?.displayId + "/home")) {
      return true;
    }
    else {

      if (
        this.currentAudio != null &&
        this.currentAudio.patientId != null &&
        this.getCurrentRoute().includes(this.currentAudio.bed!)
      ) {
        return true;
      }
    }
    return false;
  }
}

